// Analytics can only carry a numeric status code, so `navigator.credentials.get()` rejections are
// reported as stable integers. Existing values must not be renumbered once they have been logged.
// Beyond the WebAuthn spec's errors, Chrome also throws `NotSupportedError`, `NotReadableError`,
// and `OperationError` when getting an assertion.
export const UNRECOGNIZED_CREDENTIAL_ERROR_CODE = 1

const credentialErrorCodes = new Map<string, number>([
  ['NotAllowedError', 2],
  ['AbortError', 3],
  ['SecurityError', 4],
  ['TypeError', 5],
  ['NotSupportedError', 6],
  ['NotReadableError', 7],
  ['OperationError', 8],
])

export function getCredentialErrorCode(error: unknown): number {
  const name = typeof error === 'object' && error !== null && 'name' in error ? error.name : undefined
  return (typeof name === 'string' && credentialErrorCodes.get(name)) || UNRECOGNIZED_CREDENTIAL_ERROR_CODE
}
